export const FIND_FILE_REFERENCES_FAILURE = 'FIND_FILE_REFERENCES_FAILURE';

export const findFileReferencesFailure = ( payload: Error ) => ({
    type: FIND_FILE_REFERENCES_FAILURE,
    payload,
});
